import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import RecipeWishlist from '~/models/recipe-wishlist';
import { useUser } from '~/composables/_next/useUser';
import { useToaster } from '~/composables/_next/useToaster';
import { ADD_RECIPE_TO_WISHLIST_ACTION, ADD_RECIPE_WISHLIST_DRAFT, REMOVE_RECIPE_FROM_WISHLIST_ACTION, CHANGE_WISHLIST_NAME_ACTION, RECIPE_WISHLIST_MAX_CHAR, RECIPE_WISHLIST_MAX_LIST } from '~/constants/recipesConstants';
export function useRecipesWishlists() {
  var _useToaster = useToaster(),
    showToast = _useToaster.show;
  var _useUser = useUser(),
    isAuthenticated = _useUser.isAuthenticated;
  var _useNuxt2App = useNuxt2App(),
    i18n = _useNuxt2App.i18n,
    api = _useNuxt2App.$vsf.$ct.api;
  var recipesWishlists = useState('store-recipesWishlists', function () {
    return [];
  });
  function getWishlistById(wishlistId) {
    return recipesWishlists.value.find(function (w) {
      return w.id === wishlistId;
    });
  }
  function addRecipesWishlist(_x) {
    return _addRecipesWishlist.apply(this, arguments);
  }
  function _addRecipesWishlist() {
    _addRecipesWishlist = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(name) {
      var recipeName, draft, toastMessage;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            recipeName = validateRecipeName(name);
            if (!(recipeName !== true)) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", recipeName);
          case 3:
            draft = ADD_RECIPE_WISHLIST_DRAFT;
            draft.name[0].value = name;
            _context.next = 7;
            return api.createShoppingList(draft);
          case 7:
            _context.next = 9;
            return loadRecipesWishlists(true);
          case 9:
            toastMessage = i18n.t('sidebars.create-recipe-wishlist.toasts.wishlist-added', {
              name: name
            });
            showToast({
              title: toastMessage,
              iconName: 'checkmark'
            }, 2000);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _addRecipesWishlist.apply(this, arguments);
  }
  function validateRecipeName(name) {
    if (recipesWishlists.value.length >= RECIPE_WISHLIST_MAX_LIST) {
      showToast({
        title: i18n.t('sidebars.create-recipe-wishlist.toasts.add-wishlist-limit-reached')
      }, 2000);
      return i18n.t('sidebars.create-recipe-wishlist.toasts.add-wishlist-limit-reached');
    } else if (name.length > RECIPE_WISHLIST_MAX_CHAR) {
      showToast({
        title: i18n.t('sidebars.create-recipe-wishlist.toasts.add-wishlist-too-long')
      }, 2000);
      return i18n.t('sidebars.create-recipe-wishlist.toasts.add-wishlist-too-long');
    } else if (name.length < 1) {
      showToast({
        title: i18n.t('sidebars.create-recipe-wishlist.toasts.add-wishlist-too-short')
      }, 2000);
      return i18n.t('sidebars.create-recipe-wishlist.toasts.add-wishlist-too-short');
    }
    return true;
  }
  function loadRecipesWishlists() {
    return _loadRecipesWishlists.apply(this, arguments);
  }
  function _loadRecipesWishlists() {
    _loadRecipesWishlists = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var force,
        response,
        recipesWishlistsResult,
        _args2 = arguments;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            force = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
            if (!((recipesWishlists.value.length > 0 || !isAuthenticated.value) && !force)) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            _context2.next = 5;
            return api.getShoppingLists({
              getMe: 'recipesListCustom'
            });
          case 5:
            response = _context2.sent;
            if (response !== null && response !== void 0 && response.data) {
              recipesWishlistsResult = response.data.me.shoppingLists.results;
              recipesWishlists.value = recipesWishlistsResult.map(function (result) {
                return RecipeWishlist.fromQueryResult(result);
              });
            }
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _loadRecipesWishlists.apply(this, arguments);
  }
  function isInRecipesWishlists(recipeCntfId) {
    return recipesWishlists.value.some(function (wishlist) {
      return wishlist.items.some(function (item) {
        return item.contentfulId === recipeCntfId;
      });
    });
  }
  function addRecipeToWishlist(_x2, _x3) {
    return _addRecipeToWishlist.apply(this, arguments);
  }
  function _addRecipeToWishlist() {
    _addRecipeToWishlist = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(wishlistId, recipeData) {
      var wishlist, action;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            wishlist = getWishlistById(wishlistId);
            if (wishlist) {
              _context3.next = 4;
              break;
            }
            showToast({
              title: i18n.t('sidebars.add-recipe-to-wishlist.toasts.toasts.error')
            }, 2000);
            return _context3.abrupt("return");
          case 4:
            if (!((wishlist === null || wishlist === void 0 ? void 0 : wishlist.items.length) >= 100)) {
              _context3.next = 7;
              break;
            }
            showToast({
              title: i18n.t('sidebars.add-recipe-to-wishlist.toasts.add-recipe-limit-reached')
            }, 2000);
            return _context3.abrupt("return");
          case 7:
            if (!(!wishlist || isInRecipesWishlists(recipeData.contentfulId))) {
              _context3.next = 10;
              break;
            }
            if (isInRecipesWishlists(recipeData.contentfulId)) {
              showToast({
                title: i18n.t('sidebars.add-recipe-to-wishlist.toasts.add-duplicate')
              }, 2000);
            } else {
              showToast({
                title: i18n.t('sidebars.add-recipe-to-wishlist.toasts.error')
              });
            }
            return _context3.abrupt("return");
          case 10:
            action = buildAddRecipeToWishlistAction(recipeData);
            _context3.next = 13;
            return api.updateRecipesWishlistAction({
              actions: [action],
              id: wishlistId,
              version: wishlist.version
            });
          case 13:
            _context3.next = 15;
            return loadRecipesWishlists(true);
          case 15:
            showToast({
              title: i18n.t('sidebars.add-recipe-to-wishlist.toasts.recipe-added', {
                name: wishlist.name
              }),
              iconName: 'checkmark'
            }, 2000);
          case 16:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _addRecipeToWishlist.apply(this, arguments);
  }
  function removeRecipeFromWishlist(_x4) {
    return _removeRecipeFromWishlist.apply(this, arguments);
  }
  /**
   * Updates the given wishlist name
   *
   * @param      {RecipeWishlist}           wishlist  The wishlist
   * @param      {string}                   name      The name
   * @return     {Promise<RecipeWishlist>}  The updated wishlist
   */
  function _removeRecipeFromWishlist() {
    _removeRecipeFromWishlist = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(recipeCntfId) {
      var _wishlist$items$find;
      var wishlist, recipeId, action;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            wishlist = recipesWishlists.value.find(function (w) {
              return w.items.map(function (i) {
                return i.contentfulId;
              }).includes(recipeCntfId);
            });
            if (wishlist) {
              _context4.next = 4;
              break;
            }
            showToast({
              title: i18n.t('recipeWishlist.toasts.error')
            }, 2000);
            return _context4.abrupt("return");
          case 4:
            recipeId = (_wishlist$items$find = wishlist.items.find(function (i) {
              return i.contentfulId === recipeCntfId;
            })) === null || _wishlist$items$find === void 0 ? void 0 : _wishlist$items$find.id;
            action = buildRemoveRecipeFromWishlistAction(recipeId);
            _context4.next = 8;
            return api.updateRecipesWishlistAction({
              actions: [action],
              id: wishlist.id,
              version: wishlist.version
            });
          case 8:
            _context4.next = 10;
            return loadRecipesWishlists(true);
          case 10:
            showToast({
              title: i18n.t('recipeWishlist.toasts.removedRecipe', {
                name: wishlist.name
              }),
              iconName: 'checkmark'
            }, 2000);
          case 11:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _removeRecipeFromWishlist.apply(this, arguments);
  }
  function changeRecipeWishlistName(_x5, _x6) {
    return _changeRecipeWishlistName.apply(this, arguments);
  }
  /**
   * Removes the given recipe wishlist.
   *
   * @param      {RecipeWishlist}  wishlist  The wishlist
   */
  function _changeRecipeWishlistName() {
    _changeRecipeWishlistName = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(wishlist, name) {
      var _result$data;
      var action, result;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (wishlist) {
              _context5.next = 3;
              break;
            }
            showToast({
              title: i18n.t('sidebars.edit-wishlist.toasts.error')
            }, 2000);
            return _context5.abrupt("return");
          case 3:
            if (!(name.length > RECIPE_WISHLIST_MAX_CHAR)) {
              _context5.next = 8;
              break;
            }
            showToast({
              title: i18n.t('sidebars.edit-wishlist.toasts.add-wishlist-too-long')
            }, 2000);
            return _context5.abrupt("return");
          case 8:
            if (!(name.length < 1)) {
              _context5.next = 11;
              break;
            }
            showToast({
              title: i18n.t('sidebars.edit-wishlist.toasts.add-wishlist-too-short')
            }, 2000);
            return _context5.abrupt("return");
          case 11:
            action = buildChangeWishlistNameAction(name);
            _context5.next = 14;
            return api.updateRecipesWishlistAction({
              actions: [action],
              id: wishlist.id,
              version: wishlist.version
            });
          case 14:
            result = _context5.sent;
            _context5.next = 17;
            return loadRecipesWishlists(true);
          case 17:
            return _context5.abrupt("return", result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.wishlist);
          case 18:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return _changeRecipeWishlistName.apply(this, arguments);
  }
  function removeRecipeWishlist(_x7) {
    return _removeRecipeWishlist.apply(this, arguments);
  }
  function _removeRecipeWishlist() {
    _removeRecipeWishlist = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(wishlist) {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (wishlist) {
              _context6.next = 3;
              break;
            }
            showToast({
              title: i18n.t('sidebars.remove-wishlist.toasts.error')
            }, 2000);
            return _context6.abrupt("return");
          case 3:
            _context6.next = 5;
            return api.removeRecipeWishlist({
              id: wishlist.id,
              version: wishlist.version
            });
          case 5:
            _context6.next = 7;
            return loadRecipesWishlists(true);
          case 7:
            showToast({
              title: i18n.t('sidebars.remove-wishlist.toasts.wishlist-removed', {
                name: wishlist.name
              }),
              iconName: 'checkmark'
            }, 2000);
          case 8:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return _removeRecipeWishlist.apply(this, arguments);
  }
  function buildAddRecipeToWishlistAction(recipeData) {
    var action = ADD_RECIPE_TO_WISHLIST_ACTION;
    action.addTextLineItem.name[0].value = recipeData.name;
    var contentfulIdIndex = action.addTextLineItem.custom.fields.findIndex(function (field) {
      return field.name === 'contentful-id';
    });
    var imageIndex = action.addTextLineItem.custom.fields.findIndex(function (field) {
      return field.name === 'image';
    });
    action.addTextLineItem.custom.fields[contentfulIdIndex].value = "\"".concat(recipeData.contentfulId, "\"");
    action.addTextLineItem.custom.fields[imageIndex].value = "\"".concat(recipeData.image, "\"");
    return action;
  }
  function buildRemoveRecipeFromWishlistAction(recipeId) {
    var action = REMOVE_RECIPE_FROM_WISHLIST_ACTION;
    action.removeTextLineItem.textLineItemId = recipeId;
    return action;
  }
  function buildChangeWishlistNameAction(name) {
    var action = CHANGE_WISHLIST_NAME_ACTION;
    action.changeName.name[0].value = name;
    return action;
  }
  function resetRecipesWishlists() {
    recipesWishlists.value = [];
  }
  var canAddNewList = computed(function () {
    return recipesWishlists.value.length < 5;
  });
  return {
    recipesWishlists: readonly(recipesWishlists),
    validateRecipeName: validateRecipeName,
    addRecipesWishlist: addRecipesWishlist,
    loadRecipesWishlists: loadRecipesWishlists,
    addRecipeToWishlist: addRecipeToWishlist,
    isInRecipesWishlists: isInRecipesWishlists,
    canAddNewList: canAddNewList,
    removeRecipeFromWishlist: removeRecipeFromWishlist,
    resetRecipesWishlists: resetRecipesWishlists,
    changeRecipeWishlistName: changeRecipeWishlistName,
    getWishlistById: getWishlistById,
    removeRecipeWishlist: removeRecipeWishlist
  };
}